<template>
  <div class="box" :class="{'error': $props.error}, classN">
    <label class="label" :for="'select_' + $props.name">{{ options.name }}</label>
    <div class="select">
      <svg class="ico">
        <use :xlink:href="icon"></use>
      </svg>
      <select @change="change($event)" :name="search" :id="'select_' + $props.name" :value="$attrs.data">
        <option value="" disabled selected>
          {{ placeholder }}
          <span v-if="required">*</span>
        </option>
        <option v-for="(opts, index) in options" :key="'select ' + index" :value="opts">{{ opts + ' ' + name }}</option>
      </select>
    </div>
  </div>
</template>

<script>
export default {
  props: {
      name: String,
      icon: String,
      error: Boolean,
      search: String,
      options: {
          type: Array,
          required: true
      },
      classN: String,
      placeholder: String,
      required: Boolean
  },
  methods: {
    change: function(event) {
      this.$emit('track', this.$props.name + "_filter_change");
      this.$emit('update:data', event.target.value);
    }
  }
}
</script>

<style scoped lang="scss">
@import 'app/assets/stylesheets/_vars.scss';

.box.error .select{
  border: 0.063rem solid $col_red;
  color: $col_red;
  background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E%3Csvg enable-background='new 0 0 500 500' version='1.1' viewBox='0 0 500 500' xml:space='preserve' xmlns='http://www.w3.org/2000/svg'%3E%3Cg transform='translate%28-186 -303%29'%3E%3Cg transform='translate%2820 281%29'%3E%3Cg transform='translate%28160 15%29'%3E%3Cpath d='m29.729 155.09c0-4.702 1.671-9.28 5.015-12.817 6.735-7.074 17.638-7.074 24.324 0l193.9 204.46 193.97-204.46c6.688-7.074 17.639-7.074 24.324 0 6.688 7.075 6.688 18.559 0 25.609l-197.48 208.07c-11.51 12.114-30.117 12.114-41.502 0l-197.53-208.07c-3.344-3.513-5.014-8.19-5.014-12.792z' fill='%23FC5C30'/%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E ");

  select {
    color: $col_red;
  }
}

.select {
  overflow: hidden;
  position: relative;
  box-sizing: border-box;
  border-radius: .3rem;
  border: 0.125rem solid #9B9B9B;

  &:focus-within {
    box-shadow: 0 .125rem 1.25rem 0 #D3EFE4;
  }

  svg {
    left: .938rem;
    width: 1.25rem;
    position: absolute;
    height: 1.25rem;
    top: 50%;
    margin-top: -0.625rem;
    display: none;
  }

  .light & {
     border: 0.0625rem solid #DEDEDE;
    height: 2.188rem;
    line-height: 2.188rem;
    font-size: .688rem;
    font-weight: 700;

    svg {
      display: block;
    }

    select {
      height: 2.188rem;
      line-height: 2.188rem;
      font-size: .688rem;
      font-weight: 700;
      padding: 0 2.5rem;
    }
  }

  .dark & {
    border: .125rem solid #9B9B9B;
  }

  &:after {
    content: '';
    position: absolute;
    top: 50%;
    right: 1.25rem;
    transform: translateY(-50%);
    border-left: .375rem solid transparent;
    border-right: .375rem solid transparent;
    border-top: .375rem solid #000;
  }

  select {
    padding: 0 1.25rem;
    background-color: #FAFAFA;
    box-sizing: border-box;
    width: 130%;
    line-height: 3rem;
    height: 3rem;
    border: none;
    font-size: .875rem;
    text-transform: uppercase;
    font-weight: 700;
    box-shadow: none;
    appearance: none;
    cursor: pointer;

    .isIE & {
      width: 140%;
    }
  }

  select:focus {
    outline: none;
  }
}

span {
  color: $col_red;
}

@media #{$desktop} {
  .select {
    width: 12rem;

    svg {
      display: block;
    }

    select {
      padding: 0 3.5rem;
    }
  }
}

@media #{$xs-phone} {
  .light .select{
    select {
      padding: 0 0.5rem;
    }

    svg {
      display: none;
    }
  }
}
</style>